import React, { useEffect, useState } from 'react';
// import { _$, _addClass, _removeClass, _setText } from '../../../controllers/dom';
import { BsClipboardPlus } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import { NotificationManager } from 'react-notifications';
import { locales } from '../../../../translations/locales';
import Loading from '../../../Loading';
import BtnStatus from '../status/BtnStatus';
import { _$ } from '../../../../controllers/dom';

const ManagePlayer = (props) => {
    const { theme, locale, ModuleRP, data, setActivePage } = props;

    const [loaded, setLoaded] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [ranks, setRanks] = useState([]);
    const [skills, setSkills] = useState([]);
    const [assignments, setAssignments] = useState([]);

    const copyClipboard = () => {
        navigator.clipboard.writeText(data.id)
            .then(() => {
                NotificationManager.success(locales[locale].notifications.copySuccess, '', 3000);
            })
            .catch(() => {
                NotificationManager.error(locales[locale].notifications.copyError, '', 3000);
            });
    };
    const addRank = () => {
        setRanks((prevRanks) => {
            if (!prevRanks.includes(_$('rank').value)) {
                return [...prevRanks, _$('rank').value];
            }
            return prevRanks;
        });
    };
    const removeRank = (rank) => {
        setRanks((prevRanks) => prevRanks.filter((r) => r !== rank));
    };
    const addSkill = () => {
        setSkills((prevSkills) => {
            if (!prevSkills.includes(_$('skill').value)) {
                return [...prevSkills, _$('skill').value];
            }
            return prevSkills;
        });
    };
    const removeSkill = (skill) => {
        setSkills((prevSkills) => prevSkills.filter((s) => s !== skill));
    };
    const addAssignment = () => {
        setAssignments((prevAssignments) => {
            if (!prevAssignments.includes(_$('building').value)) {
                return [...prevAssignments, _$('building').value];
            }
            return prevAssignments;
        });
    };
    const removeAssignment = (assignment) => {
        setAssignments((prevAssignments) => prevAssignments.filter((a) => a !== assignment));
    };
    const updatePlayer = () => {
        const alias = _$('alias').value;
        ModuleRP.config.updatePlayer(data.player.id,
            ['alias', 'ranks', 'skills', 'assignments', 'missionId', 'vehicleId'],
            [alias, ranks, skills, assignments, null, null],
        );
        setActivePage('Players');
    };

    useEffect(() => {
        if (!loaded && data.player && data.player.type === 'player') {
            for (const rank of data.player.ranks) {
                setRanks((prevRanks) => [...prevRanks, rank]);
            }
            for (const skill of data.player.skills) {
                setSkills((prevSkills) => [...prevSkills, skill]);
            }
            for (const assignment of data.player.assignments) {
                setAssignments((prevAssignments) => [...prevAssignments, assignment]);
            }
            setLoaded(true);
        }
    }, [data, ranks, skills, assignments]);

    return (
        data.player && data.player.type === 'player' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">{locales[locale].config.managePlayer} {data.name}</h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <h5 className="card-title">
                            <BtnStatus listStatus={data.listStatus} code={data.player.status} text={data.player.name} />
                        </h5>
                        <p className="card-text text-secondary"></p>
                        <div className="card-text text-secondary">
                            <span className={`text-${theme === 'DARK' ? 'light' : 'dark'}`}>
                                {data.player.id}
                            </span>
                            <span
                                className={`text-${theme === 'DARK' ? 'light' : 'dark'} m-1 cursor-pointer`}
                                data-tip data-tooltip-id='copy'
                                onClick={copyClipboard}
                            >
                                <BsClipboardPlus />
                                <Tooltip id='copy' place='top' effect='solid' className='text-center'>
                                    {locales[locale].config.copyClipboard}
                                </Tooltip>
                            </span>
                        </div>
                        <h5 className="card-title">{locales[locale].config.alias}</h5>
                        <input
                            type='text'
                            className='form-control w-25'
                            id='alias'
                            placeholder={data.player.alias}
                            defaultValue={data.player.alias}
                            maxLength={35}
                        />
                        <h5 className="card-title">{locales[locale].config.ranks}</h5>
                        <div className="m-2 ml-5">
                            {ranks.map((rank) => (
                                <span
                                    key={rank}
                                    className='btn btn-sm btn-primary p-1 m-1'
                                    onClick={() => removeRank(rank)}
                                    data-tip data-tooltip-id='rank'
                                >
                                    {data.listRanks.find((rankObject) => rankObject.id === rank).name}
                                    <Tooltip id='rank' place='top' effect='solid' className='text-center'>
                                        {locales[locale].delete}
                                    </Tooltip>
                                </span>
                            ))}
                        </div>
                        <div className="row">
                            <div className="col-sm-8">
                                <form onSubmit={(event) => {
                                    event.preventDefault();
                                    addRank();
                                }}>
                                    <select className='form-control' id='rank'>
                                        (
                                        {data.listRanks.map((rank) => (
                                            <option key={rank.id} value={rank.id}>{rank.name}</option>
                                        ))}
                                        )
                                    </select>
                                    <button type='button' className='btn btn-sm btn-primary float-right m-1' onClick={addRank}>
                                        {locales[locale].config.add}
                                    </button>
                                </form>
                            </div>
                        </div>
                        <h5 className="card-title">{locales[locale].config.skills}</h5>
                        <div className="m-2 ml-5">
                            {skills.map((skill) => (
                                <span
                                    key={skill}
                                    className='btn btn-sm btn-primary p-1 m-1'
                                    onClick={() => removeSkill(skill)}
                                    data-tip data-tooltip-id='skill'
                                >
                                    {data.listSkills.find((skillObject) => skillObject.id === skill).name}
                                    <Tooltip id='skill' place='top' effect='solid' className='text-center'>
                                        {locales[locale].delete}
                                    </Tooltip>
                                </span>
                            ))}
                        </div>
                        <div className="row">
                            <div className="col-sm-8">
                                <form onSubmit={(event) => {
                                    event.preventDefault();
                                    addSkill();
                                }}>
                                    <select className='form-control' id='skill'>
                                        {data.listSkills.map((skill) => (
                                            <option key={skill.id} value={skill.id}>{skill.name}</option>
                                        ))}
                                    </select>
                                    <button type='button' className='btn btn-sm btn-primary float-right m-1' onClick={addSkill}>
                                        {locales[locale].config.add}
                                    </button>
                                </form>
                            </div>
                        </div>
                        <h5 className="card-title">{locales[locale].config.assignments}</h5>
                        <div className="m-2 ml-5">
                            {assignments.map((assignment) => (
                                <span
                                    key={assignment}
                                    className='btn btn-sm btn-primary p-1 m-1'
                                    onClick={() => removeAssignment(assignment)}
                                    data-tip data-tooltip-id='assignment'
                                >
                                    {data.listBuildings.find((building) => building.id === assignment)?.name}
                                    <Tooltip id='assignment' place='top' effect='solid' className='text-center'>
                                        {locales[locale].delete}
                                    </Tooltip>
                                </span>
                            ))}
                        </div>
                        <div className="row">
                            <div className="col-sm-8">
                                <form onSubmit={(event) => {
                                    event.preventDefault();
                                    addAssignment();
                                }}>
                                    <select className='form-control' id='building'>
                                        {data.listBuildings.map((building) => (
                                            <option key={building.id} value={building.id}>{building.name}</option>
                                        ))}
                                    </select>
                                    <button type='button' className='btn btn-sm btn-primary float-right m-1' onClick={addAssignment}>
                                        {locales[locale].config.add}
                                    </button>
                                </form>
                            </div>
                        </div>
                        <button
                            type='button' id='btn-confirm-update-player' className="btn btn-primary float-right" onClick={updatePlayer}>
                            {locales[locale].config.update}
                        </button>
                    </div>
                </div>
                <div className="card container p-0 gameInformations mt-5 mb-2">
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <div className="row">
                            <div className="col-sm-8"></div>
                            <div className='col h-25 btn btn-danger' onClick={() => setConfirmDelete(true)}>
                                {locales[locale].config.deletePlayer}
                            </div>
                        </div>
                        <div className={confirmDelete ? '' : 'hide'} id="deleteBuilding">
                            <hr className={`m-1 bg-secondary`} />
                            <div>
                                {locales[locale].config.deleteConfirmPlayer}
                            </div>
                            <div className="text-center">
                                <button className='btn btn-sm btn-secondary w-25 m-3' onClick={() => setConfirmDelete(false)}>
                                    {locales[locale].no}
                                </button>
                                <button
                                    className='btn btn-sm btn-danger w-25 m-3'
                                    id='btn-delete-building'
                                    onClick={() => {
                                        ModuleRP.config.deletePlayer(data.player.id);
                                    }}
                                >
                                    {locales[locale].yes}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default ManagePlayer;
